// Toaster.js
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { toaster } from '../Recoil/ActiveEvents';

const Notification = ({ message, onClose }) => {
  const [showNotification,setShowNotification] = useRecoilState(toaster)
  useEffect(() => {
    const timer = setTimeout(() => {
      // onClose();
      setShowNotification({showPopup:false, message:''})
    }, 5000);
    return () => clearTimeout(timer);
  }, [showNotification]);

  return (
    <div>
      {!!showNotification && showNotification.type =="error" && (
        <div className="bg-red-600 px-8 py-3.5 fixed bottom-0 left-1/2 transform -translate-x-1/2 mb-4 sm:mb-6 md:mb-8 rounded shadow-lg transition-transform transform">
          <p className='text-white'>{showNotification.message}</p>
        </div>
      )}
      {!!showNotification && showNotification.type =="success" && (
        <div className="bg-emerald-600 px-8 py-3.5 fixed bottom-0 left-1/2 transform -translate-x-1/2 mb-4 sm:mb-6 md:mb-8 rounded shadow-lg transition-transform transform">
          <p className='text-white font-medium'>{showNotification.message}</p>
        </div>
      )}
      {!!showNotification && showNotification.type =="warning" && (
        <div className="bg-yellow-500 px-24 py-3.5 fixed top-2 left-1/2 transform -translate-x-1/2 mb-4 sm:mb-6 md:mb-8 rounded shadow-lg transition-transform transform">
          <p className='text-black font-medium'>{showNotification.message}</p>
        </div>
      )}
    </div>
  );
};

export default Notification;
